import Image from "next/image";
import { FC } from "react";
import Slider from "react-slick";

const logos = [
  { src: "/images/bmw-spares.webp", alt: "BMW spares, BMW parts, OEM BMW Parts, Pirate BMW parts, second hand BMW spares" },
  { src: "/images/haval-spares.webp", alt: "Haval spares, Haval parts, OEM Haval Parts, Pirate Haval parts" },
  { src: "/images/volkswagen-spares.webp", alt: "Volkswagen spares, Volkswagen parts, OEM Volkswagen Parts, Pirate Volkswagen parts, second hand Volkswagen spares" },
  { src: "/images/toyota-spares.webp", alt: "Toyota spares, Toyota parts, OEM Toyota Parts, Pirate Toyota parts, second hand Toyota spares" },
  { src: "/images/nissan-spares.webp", alt: "Nissan spares, Nissan parts, OEM Nissan Parts, Pirate Nissan parts, second hand Nissan spares" },
  { src: "/images/kia-spares.webp", alt: "Kia spares, Kia parts, OEM Kia Parts, Pirate Kia parts, second hand Kia spares" },
  { src: "/images/land-rover-spares.webp", alt: "Land Rover spares, Land Rover parts, OEM Land Rover Parts, Pirate Land Rover parts, second hand Land Rover spares" },
  { src: "/images/porsche-spares.webp", alt: "Porsche spares, Porsche parts, OEM Porsche Parts, Pirate Porsche parts, second hand Porsche spares" },
   { src: "/images/ford-spares.webp", alt: "Ford spares, Ford parts, OEM Ford Parts, Pirate Ford parts, second hand Ford spares" },
];

const PartnerLogosSlider: FC = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 750, settings: { slidesToShow: 3 } },
      { breakpoint: 500, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Slider {...settings} className="container">
      {logos.map((logo, index) => (
        <div key={index} className="aspect-3/2 h-[100px] px-10">
          <Image
            src={logo.src}
            width={385}
            height={131}
            alt={logo.alt}
            className="w-full h-full object-contain"
          />
        </div>
      ))}
    </Slider>
  );
};

export default PartnerLogosSlider;
